import { Grid } from '@mui/material';
import { adminSupportMaster, subdistributorTypes } from '../utils/constant';
import { adminSupportValues } from './adminSupport';
import MFSelectField from '../lib/formik/SelectField';
import { useEffect, useState } from 'react';
import {
  DistributorListType,
  RmsType,
  SubDistributorListType,
} from '../redux-store/types/api-types';
import { getDistributor } from '../utils/utilityFunctions';
import { getDistributorById } from '../redux-store/actions/userManagement';
import { MFTextField } from '../lib/formik';
import { FormikHelpers } from 'formik';
import { useDispatch } from 'react-redux';
import { getDistributorsListForFilters, getRMsList } from '../redux-store/actions';
import { Notes } from './investors/components';
import MFCheckbox from '../lib/formik/Checkbox';

export const UpdateMakerAndCreateTopup = ({
  values,
  setValues,
}: {
  values: adminSupportValues;
  setValues: FormikHelpers<adminSupportValues>['setValues'];
}): JSX.Element => {
  const [rmList, setRmList] = useState<RmsType[]>([]);
  const [supportRmList, setSupportRmList] = useState<RmsType[]>([]);
  const [distributorData, setDistributorData] = useState<DistributorListType[]>([]);
  const [subDistributorData, setSubDistributorData] = useState<SubDistributorListType[]>([]);

  const dispatch = useDispatch();
  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        if (
          adminSupportMaster[values?.supportType] ===
          adminSupportMaster.create_topup_move_distributor
        ) {
          const rmList = (await dispatch(
            getRMsList({ roleType: 'amc_rm', isActive: true })
          )) as unknown as RmsType[];
          if (!isComponentActive) {
            return;
          }
          setRmList(rmList || []);
          setValues({
            ...values,
            supportType: values?.supportType,
            phone: '',
            status: '',
          });
          return;
        }
        if (!isComponentActive) {
          return;
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [values.supportType]);

  return (
    <>
      {[adminSupportMaster.create_topup_move_distributor].includes(
        adminSupportMaster[values.supportType]
      ) && (
        <>
          <Grid item xs={12}>
            <Notes
              displayContent="Please select the Makers from the list below. If you are unable to find the required Makers, please contact the support team."
              displayContent1="No Existing Makers in TopUp Application Will be present After Creation of topup using this Method. So select All Makers required For the Top Up Application here"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFSelectField
              name={`rm_id`}
              label={'Select Direct(AMC) RM *'}
              items={rmList.map((item) => ({
                key: item.name,
                value: item.id,
              }))}
              applyLabelStyles={true}
              onChange={(e) => {
                const selectedMaker = rmList.find((item) => item?.id == e.target.value) as RmsType;
                setValues({
                  ...values,
                  rm_id: e.target.value as string,
                  rm_email: selectedMaker?.user.email,
                  rm_mobile: selectedMaker?.user.phone,
                });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              label={`Direct(AMC) RM Email*`}
              name="rm_email"
              placeholder="Enter RM Email"
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              label={`Direct(AMC) RM Phone Number*`}
              name="rm_mobile"
              placeholder="Enter RM Phone Number"
              disabled={true}
            />
          </Grid>
          <Grid item xs={12}>
            <MFCheckbox
              name={`enableSupportRM`}
              label={`Add Service RM`}
              // checked={values.enableSupportRM}
              onChange={async ({ target: { checked } }) => {
                if (checked && supportRmList.length === 0) {
                  const res = (await dispatch(
                    getRMsList({ roleType: 'support_rm', isActive: true })
                  )) as unknown as RmsType[];
                  setSupportRmList(res || []);
                }
                setValues({
                  ...values,
                  enableSupportRM: !!checked || false,
                });
              }}
            />
          </Grid>
          {console.log('values', values)}
          {values.enableSupportRM && (
            <>
              <Grid item xs={12} sm={6}>
                <MFSelectField
                  name={`support_rm_id`}
                  label={'Select Service RM *'}
                  items={supportRmList.map((item) => ({
                    key: item.name,
                    value: item.id,
                  }))}
                  applyLabelStyles={true}
                  onChange={(e) => {
                    const selectedMaker = supportRmList.find(
                      (item) => item?.id == e.target.value
                    ) as RmsType;
                    setValues({
                      ...values,
                      support_rm_id: e.target.value as string,
                      support_rm_email: selectedMaker?.user.email,
                      support_rm_mobile: selectedMaker?.user.phone,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MFTextField
                  label={`Service RM Email*`}
                  name="support_rm_email"
                  placeholder="Enter RM Email"
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MFTextField
                  label={`Service RM Phone Number*`}
                  name="support_rm_mobile"
                  placeholder="Enter RM Phone Number"
                  disabled={true}
                />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <MFCheckbox
              name={`enableDistributor`}
              label={`Add Distributor`}
              checked={!!values.enableDistributor}
              onChange={async ({ target: { checked } }) => {
                if (checked && distributorData.length === 0) {
                  const res = (await dispatch(
                    getDistributorsListForFilters()
                  )) as unknown as DistributorListType[];
                  setDistributorData(res || []);
                }
                setValues({
                  ...values,
                  enableDistributor: !!checked,
                });
              }}
            />
          </Grid>
          {values.enableDistributor && (
            <>
              <Grid item xs={12} sm={6}>
                <Grid xs={12} sm={12}>
                  <MFSelectField
                    name={`distributor_id`}
                    label={'Distributor *'}
                    items={distributorData.map((item) => ({
                      key: item.name,
                      value: item.id,
                    }))}
                    applyLabelStyles={true}
                    onChange={async (e) => {
                      const selectedDistributor = getDistributor(
                        e.target.value as string,
                        distributorData
                      ) as DistributorListType;
                      const isDistributorIndividual = selectedDistributor?.type === 'individual';
                      // setSubDistributorData(selectedDistributor?.subdistributors || []);
                      const res = (await dispatch(
                        getDistributorById(e.target.value as number)
                      )) as unknown as DistributorListType;
                      if (!isDistributorIndividual) {
                        setSubDistributorData(res.subdistributors);
                      }
                      // setFieldValue('supportType', e.target.value);
                      setValues({
                        ...values,
                        distributor_id: e.target.value as string,
                        subdistributorId: '',
                        distributorEmail: res?.user?.email || '',
                        distributorPhone: res?.user?.phone || '',
                        enableSubDistributor: !isDistributorIndividual,
                        arnCode: selectedDistributor?.arnCode,
                      });
                    }}
                  />
                </Grid>
              </Grid>
              {values.distributor_id && (
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`arnCode`}
                    label={`Distributor Code*`}
                    placeholder="Enter Distributor Code"
                    disabled={true}
                  />
                </Grid>
              )}
              {values.enableSubDistributor && values.distributor_id && (
                <Grid item xs={12} sm={6}>
                  <Grid xs={12} sm={12}>
                    <MFSelectField
                      name={`subdistributorId`}
                      label={`Distributor's RM *`}
                      items={subDistributorData
                        .filter(
                          (ele) =>
                            subdistributorTypes[ele.subdistributorType || ''] ===
                            subdistributorTypes.direct
                        )
                        .map((item) => ({
                          key: item.user.firstName,
                          value: item.id,
                        }))}
                      applyLabelStyles={true}
                      onChange={(e) => {
                        const selectedSubDistributor = getDistributor(
                          e.target.value as string,
                          subDistributorData
                        ) as SubDistributorListType;
                        // setFieldValue('supportType', e.target.value);
                        setValues({
                          ...values,
                          subdistributorId: e.target.value as string,
                          distributorEmail: selectedSubDistributor?.user.email,
                          distributorPhone: selectedSubDistributor?.user?.phone,
                        });
                      }}
                    />
                  </Grid>
                </Grid>
              )}
              {((!values.enableSubDistributor && values.distributor_id) ||
                (values.enableSubDistributor && values.subdistributorId)) && (
                <>
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      label={`Distributor${values.subdistributorId ? "'s RM" : ''} Email *`}
                      name="distributorEmail"
                      placeholder="Enter Sub Distributor Email"
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      label={`Distributor${values.subdistributorId ? "'s RM" : ''} Phone Number *`}
                      name="distributorPhone"
                      placeholder="Enter Distributor Phone Number"
                      disabled={true}
                    />
                  </Grid>
                </>
              )}
              {values.enableSubDistributor && values.distributor_id && (
                <>
                  <Grid item xs={12}>
                    <MFCheckbox
                      name={`enableSupportDistributor`}
                      label={`Add CSE`}
                      checked={values.enableSupportDistributor}
                      onChange={({ target: { checked } }) => {
                        setValues({
                          ...values,
                          enableSupportDistributor: !!checked,
                        });
                      }}
                    />
                  </Grid>
                  {values.enableSupportDistributor && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <MFSelectField
                          name={`supportSubdistributorId`}
                          label={'Select CSE *'}
                          items={subDistributorData
                            .filter(
                              (ele) =>
                                subdistributorTypes[ele.subdistributorType || ''] ===
                                subdistributorTypes.support
                            )
                            .map((item) => ({
                              key: item.user.firstName,
                              value: item.id,
                            }))}
                          applyLabelStyles={true}
                          onChange={(e) => {
                            const selectedSubDistributor = getDistributor(
                              e.target.value as string,
                              subDistributorData
                            ) as SubDistributorListType;
                            setValues({
                              ...values,
                              supportSubdistributorId: e.target.value as string,
                              support_distributor_email: selectedSubDistributor?.user.email,
                              support_distributor_phone: selectedSubDistributor?.user.phone,
                            });
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          label={`CSE Email*`}
                          name="support_distributor_email"
                          placeholder="Enter RM Email"
                          disabled={true}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          label={`CSE Phone Number*`}
                          name="support_distributor_phone"
                          placeholder="Enter RM Phone Number"
                          disabled={true}
                        />
                      </Grid>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default UpdateMakerAndCreateTopup;
